import { useContext, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { MultiValue } from 'react-select'
import { z } from 'zod'

import { OptionType } from '../../../../../app/utils/optionSelectType'
import { SellersContext } from '../../../../../app/contexts/SellerContex'
import { useTeams } from '../../../../../app/hooks/useTeams'
import { useQuery } from '@tanstack/react-query'
import { configService } from '@/app/services/configService'

const schema = z.object({
  sellerIds: z.array(z.string()).optional(),
  teamIds: z.array(z.string()).optional(),
})

type FormFilterData = z.infer<typeof schema>

export const useSellerFilterController = () => {
  const [selectedTeamOptions, setSelectedTeamOptions] = useState<
    MultiValue<OptionType>
  >([])
  const [onlyBlockUsers, setOnlyBlockUsers] = useState(false)
  const [onlyNonApprovedUnico, setOnlyNonApprovedUnico] = useState(false)

  const { setFilterParams } = useContext(SellersContext)

  const { data: configs } = useQuery({
    queryKey: ['configs'],
    queryFn: () => configService.getConfigsApp(),
  })

  const {
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<FormFilterData>({
    resolver: zodResolver(schema),
  })

  const {
    data: fullTeamData,
    fetchNextPage: fetchTeam,
    hasNextPage: hasTeam,
    isFetching: isFetchingTeam,
    isLoading: isLoadingTeam,
    setParams: setParamsTeam,
  } = useTeams()

  const teamsData = fullTeamData?.pages.flatMap((page) =>
    page.teams.map((team) => ({
      value: team._id,
      label: team.name,
    })),
  )

  const handleLoadMoreTeam = () => {
    if (hasTeam && !isFetchingTeam) {
      fetchTeam()
    }
  }

  const handleSelectTeam = (selectedTeamOptions: MultiValue<OptionType>) => {
    setValue(
      'teamIds',
      selectedTeamOptions?.map((option) => option.value) || [],
    )
    setSelectedTeamOptions(selectedTeamOptions)
  }

  const handleClearFilter = () => {
    reset()
    setFilterParams({
      sellerIds: undefined,
      teamIds: undefined,
    })
    setParamsTeam({
      search: '',
    })
  }

  const handleFilterSubmit = handleSubmit(async (data) => {
    try {
      let sellerIds = ''
      let teamIds = ''

      if (data.sellerIds && data.sellerIds?.length > 0) {
        sellerIds = data.sellerIds.map((sellerId) => sellerId).join(',')
      }

      if (data.teamIds && data.teamIds?.length > 0) {
        teamIds = data.teamIds.map((teamIds) => teamIds).join(',')
      }

      const params = {
        sellerIds: sellerIds || undefined,
        teamIds: teamIds || undefined,
        blockedUsers: onlyBlockUsers ? 'true' : undefined,
        unicoApproved: onlyNonApprovedUnico ? 'false' : undefined,
      }

      setFilterParams(params)
    } catch (error) {
      console.log(error)
    }
  })

  return {
    onlyBlockUsers,
    setOnlyBlockUsers,
    handleFilterSubmit,
    handleClearFilter,
    errors,
    isSubmitting,
    selectedTeamOptions,
    handleSelectTeam,
    handleLoadMoreTeam,
    isFetchingTeam,
    isLoadingTeam,
    teamsData,
    setParamsTeam,
    onlyNonApprovedUnico,
    setOnlyNonApprovedUnico,
    configs,
  }
}
